import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=14411333&scoped=true&"
import script from "./turnover.vue?vue&type=script&lang=js&"
export * from "./turnover.vue?vue&type=script&lang=js&"
import style0 from "./turnover.vue?vue&type=style&index=0&id=14411333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14411333",
  null
  
)

export default component.exports